import { useFormikContext } from "formik";
import { FC, useState } from "react";
import { useLocale } from "../../contexts/localeContext";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import EmailTemplatePreviewModal from './email-template-preview/EmailTemplatePreviewModal';
import { EmailTemplate } from "./email-template-step";

interface Props {
    showPreview: boolean;
    onBack: (event: any) => void;
    onNext: (event: any) => void;
    setSideBarStepDescription?: (newDescription) => void;
    setHideMainModal?: React.Dispatch<React.SetStateAction<boolean>>;
}

const EmailTemplateForm: FC<Props> = ({ showPreview, onNext, onBack, setSideBarStepDescription = () => { }, setHideMainModal }) => {
    const task = '';
    const description = '';
    const { translate } = useLocale();
    const { values } = useFormikContext<any>();
    const [isPreviewOpen, setIsPreviewOpen] = useState<boolean>(false);

    const onLocalNext = (event: any) => {
        if (values.emailAccountId && values.subject && values.body) {
            onNext({ ...event, task: task, description: description });
            setSideBarStepDescription(values.accountSetting)
        }
    }

    const isEnabled = () => {
        return values.emailAccountId.trim() && values.subject.trim() && values.body.trim() && values.disclaimer.trim();
    }

    const onPreviewEmail = () => {
        setIsPreviewOpen(true);
        setHideMainModal && setHideMainModal(true);
    }

    const onPreviewEmailClosed = () => {
        setIsPreviewOpen(false);
        setHideMainModal && setHideMainModal(false);
    }

    return <>
        <div className="pt-3 pr-3 pl-3 h-full relative">
            <EmailTemplate />
            <div className="flex justify-between w-full absolute bottom-0 right-0 pr-3 pb-3 ">
                {showPreview && <div className="flex flex-row mt-4">
                    <button
                        style={{ textOverflow: 'ellipsis' }}
                        className={`py-1 px-5 secondary bg-sidemenu-focus text-white`}
                        type="button" onClick={onPreviewEmail}>{translate.byKey(TranslationKeys.previewEmail)}</button>
                </div>}
                <div className="flex flex-row">
                    <div className="flex flex-row mt-4 pl-3">
                        <button
                            className="py-1 px-5 secondary secondary-inverse"
                            type="button" onClick={onBack} >{translate.byKey(TranslationKeys.back)}</button>
                    </div>
                    <div className="flex flex-row justify-end mt-4 pl-3">
                        <button
                            className={`py-1 px-5 secondary ${isEnabled() ? 'secondary-enabled' : 'secondary-disabled cursor-not-allowed'}`}
                            disabled={!isEnabled()}
                            type="button"
                            onClick={e => onLocalNext(e)}>{translate.byKey(TranslationKeys.next)}</button>
                    </div>
                </div>
            </div>
        </div>
        <EmailTemplatePreviewModal isPreviewOpen={isPreviewOpen} onClose={onPreviewEmailClosed} />
    </>
}

export default EmailTemplateForm;
